import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from '@/app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from '@modules/main/main.component';
import { LoginComponent } from '@modules/login/login.component';
import { HeaderComponent } from '@modules/main/header/header.component';
import { FooterComponent } from '@modules/main/footer/footer.component';
import { MenuSidebarComponent } from '@modules/main/menu-sidebar/menu-sidebar.component';
import { BlankComponent } from '@pages/blank/blank.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfileComponent } from '@pages/profile/profile.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RegisterComponent } from '@modules/register/register.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { ToastrModule } from 'ngx-toastr';
import { MessagesComponent } from '@modules/main/header/messages/messages.component';
import { NotificationsComponent } from '@modules/main/header/notifications/notifications.component';

import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import { UserComponent } from '@modules/main/header/user/user.component';
import { ForgotPasswordComponent } from '@modules/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from '@modules/recover-password/recover-password.component';
import { LanguageComponent } from '@modules/main/header/language/language.component';
import { MainMenuComponent } from './pages/main-menu/main-menu.component';
import { SubMenuComponent } from './pages/main-menu/sub-menu/sub-menu.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { ControlSidebarComponent } from './modules/main/control-sidebar/control-sidebar.component';
import { StoreModule } from '@ngrx/store';
import { authReducer } from './store/auth/reducer';
import { uiReducer } from './store/ui/reducer';
import { ProfabricComponentsModule } from '@profabric/angular-components';
import { SidebarSearchComponent } from './components/sidebar-search/sidebar-search.component';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { environment } from 'environments/environment';
import { ActivityTabComponent } from './pages/profile/activity-tab/activity-tab.component';
import { TimelineTabComponent } from './pages/profile/timeline-tab/timeline-tab.component';
import { SettingsTabComponent } from './pages/profile/settings-tab/settings-tab.component';
import { PostComponent } from './pages/profile/post/post.component';
import { InfoBoxComponent } from './components/info-box/info-box.component';
import { SmallBoxComponent } from './components/small-box/small-box.component';
import { ContentHeaderComponent } from './components/content-header/content-header.component';
import { LoadingComponent } from './components/loading/loading.component';
import { OverlayLoadingComponent } from './components/overlay-loading/overlay-loading.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { WebsiteComponent } from './pages/website/website.component';
import { WebNavbarComponent } from './pages/web-navbar/web-navbar.component';
import { WebFooterComponent } from './pages/web-footer/web-footer.component';
import { SwiperModule } from 'swiper/angular';
import { DetailViewComponent } from './pages/detail-view/detail-view.component';
import { InvoiceComponent } from './pages/invoice/invoice.component';
import { QuillModule } from 'ngx-quill';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ConfigLoader } from '@services/config.loader';
import { ConfigService } from '@services/config.service';
import { ProductViewComponent } from './pages/admin/product-view/product-view.component';
import { FilterPipe } from '@components/filter-pipe/filter.pipe';
import { EnquiryComponent } from './pages/enquiry/enquiry.component';
import { BillComponent } from './pages/bill/bill.component';
import { ShopBillListTableComponent } from './pages/admin/shop-bill-list-table/shop-bill-list-table.component';
import { CreateBoschProductComponent } from './pages/admin/create-bosch-product/create-bosch-product.component';
import { UserProfileComponent } from './pages/admin/user-profile/user-profile.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatTooltipModule } from '@angular/material/tooltip';


registerLocaleData(localeEn, 'en-EN');

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    LoginComponent,
    HeaderComponent,
    FooterComponent,
    MenuSidebarComponent,
    BlankComponent,
    ProfileComponent,
    RegisterComponent,
    DashboardComponent,
    MessagesComponent,
    NotificationsComponent,
    UserComponent,
    ForgotPasswordComponent,
    RecoverPasswordComponent,
    LanguageComponent,
    MainMenuComponent,
    SubMenuComponent,
    MenuItemComponent,
    ControlSidebarComponent,
    SidebarSearchComponent,
    ActivityTabComponent,
    TimelineTabComponent,
    SettingsTabComponent,
    PostComponent,
    InfoBoxComponent,
    SmallBoxComponent,
    ContentHeaderComponent,
    LoadingComponent,
    OverlayLoadingComponent,
    WebsiteComponent,
    WebNavbarComponent,
    WebFooterComponent,
    DetailViewComponent,
    InvoiceComponent,
    ProductViewComponent,
    FilterPipe,
    EnquiryComponent,
    BillComponent,
    ShopBillListTableComponent,
    CreateBoschProductComponent,
    UserProfileComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    ProfabricComponentsModule,
    CommonModule,
    BrowserModule,
    FormsModule,
    StoreModule.forRoot({ auth: authReducer, ui: uiReducer }),
    AppRoutingModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    NgxGoogleAnalyticsModule.forRoot(environment.GA_ID),
    FontAwesomeModule,
    QuillModule.forRoot(),
    SwiperModule,
    FormsModule,
    MatTooltipModule
  ],
  providers: [provideHttpClient(withInterceptorsFromDi()),
  {
    provide: APP_INITIALIZER,
    useFactory: ConfigLoader,
    deps: [ConfigService],
    multi: true,
  },
    DatePipe,
    provideAnimationsAsync()]
})
export class AppModule { }
